import { render, staticRenderFns } from "./AddInvestigator.vue?vue&type=template&id=70f891cf&scoped=true&"
import script from "./AddInvestigator.vue?vue&type=script&lang=js&"
export * from "./AddInvestigator.vue?vue&type=script&lang=js&"
import style0 from "./AddInvestigator.vue?vue&type=style&index=0&id=70f891cf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70f891cf",
  null
  
)

export default component.exports